/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Inline_Need_AccountInputs */

const en_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need an account? Sign up`)
};

const es_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Necesitas una cuenta? Regístrate`)
};

const de_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benötigen Sie ein Konto? Registrieren`)
};

const zh_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要账户？注册`)
};

const ar_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحتاج حساباً؟ أنشئ حساباً`)
};

const fr_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besoin d'un compte ? S'inscrire`)
};

const vi_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cần tài khoản? Đăng ký`)
};

const sw_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je, unahitaji akaunti? Jisajili`)
};

const th_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้องการบัญชี? ลงทะเบียน`)
};

const bs_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trebate račun? Registrujte se`)
};

const ja_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントが必要ですか？サインアップ`)
};

const ko_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정이 없으신가요? 회원가입`)
};

const pt_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisa de uma conta? Cadastre-se`)
};

const it_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai bisogno di un account? Registrati`)
};

const sv_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behöver du ett konto? Registrera dig`)
};

const nl_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen account? Registreren`)
};

const da_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Har du brug for en konto? Tilmeld dig`)
};

const nb_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenger du en konto? Registrer deg`)
};

const fi_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarvitsetko tiliä? Rekisteröidy`)
};

const pl_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potrzebujesz konta? Zarejestruj się`)
};

const ru_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет аккаунта? Зарегистрируйтесь`)
};

const tr_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesabınız yok mu? Kaydolun`)
};

const hi_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाता चाहिए? साइन अप करें`)
};

const id_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butuh akun? Daftar`)
};

const ms_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perlukan akaun? Daftar`)
};

const cs_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potřebujete účet? Zaregistrujte se`)
};

const el_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Χρειάζεστε λογαριασμό; Εγγραφή`)
};

const he_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צריכים חשבון? הירשמו`)
};

const af_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het jy 'n rekening nodig? Registreer`)
};

const hu_auth_inline_need_account = /** @type {(inputs: Auth_Inline_Need_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs még fiókja? Regisztráljon`)
};

/**
* | output |
* | --- |
* | "Need an account? Sign up" |
*
* @param {Auth_Inline_Need_AccountInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_inline_need_account = /** @type {((inputs?: Auth_Inline_Need_AccountInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Inline_Need_AccountInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_inline_need_account(inputs)
	if (locale === "de") return de_auth_inline_need_account(inputs)
	if (locale === "zh") return zh_auth_inline_need_account(inputs)
	if (locale === "ar") return ar_auth_inline_need_account(inputs)
	if (locale === "fr") return fr_auth_inline_need_account(inputs)
	if (locale === "vi") return vi_auth_inline_need_account(inputs)
	if (locale === "sw") return sw_auth_inline_need_account(inputs)
	if (locale === "th") return th_auth_inline_need_account(inputs)
	if (locale === "bs") return bs_auth_inline_need_account(inputs)
	if (locale === "ja") return ja_auth_inline_need_account(inputs)
	if (locale === "ko") return ko_auth_inline_need_account(inputs)
	if (locale === "pt") return pt_auth_inline_need_account(inputs)
	if (locale === "it") return it_auth_inline_need_account(inputs)
	if (locale === "sv") return sv_auth_inline_need_account(inputs)
	if (locale === "nl") return nl_auth_inline_need_account(inputs)
	if (locale === "da") return da_auth_inline_need_account(inputs)
	if (locale === "nb") return nb_auth_inline_need_account(inputs)
	if (locale === "fi") return fi_auth_inline_need_account(inputs)
	if (locale === "pl") return pl_auth_inline_need_account(inputs)
	if (locale === "ru") return ru_auth_inline_need_account(inputs)
	if (locale === "tr") return tr_auth_inline_need_account(inputs)
	if (locale === "hi") return hi_auth_inline_need_account(inputs)
	if (locale === "id") return id_auth_inline_need_account(inputs)
	if (locale === "ms") return ms_auth_inline_need_account(inputs)
	if (locale === "cs") return cs_auth_inline_need_account(inputs)
	if (locale === "el") return el_auth_inline_need_account(inputs)
	if (locale === "he") return he_auth_inline_need_account(inputs)
	if (locale === "af") return af_auth_inline_need_account(inputs)
	if (locale === "hu") return hu_auth_inline_need_account(inputs)
	return en_auth_inline_need_account(inputs)
});